import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RavIconCircled } from '@shared/icon/icon';

@Component({
  selector: 'rav-two-factor-auth',
  template: `
    <div class="grid-x grid-padding-x small-up-1 large-up-2">
      <div class="cell">
        <label
          >Require Two Factor Authentication
          <rav-icon
            matTooltip="When required, all users will be required to set up two factor authentication"
            matTooltipPosition="above"
            [name]="ravIcon.Question"
            class="question"
          ></rav-icon>
        </label>
        <select [(ngModel)]="twoFactorAuth" (change)="onChange()">
          <option [ngValue]="false">Not Required</option>
          <option [ngValue]="true">Required</option>
        </select>
      </div>
    </div>
  `,
  styles: [
    `
      .question {
        width: 0.75rem;
        height: 0.75rem;
        display: inline-flex;
        color: get-color(primary);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TwoFactorAuthComponent {
  @Input() twoFactorAuth: boolean;
  @Output() twoFactorAuthChange = new EventEmitter<boolean>();

  ravIcon: typeof RavIconCircled = RavIconCircled;

  onChange() {
    this.twoFactorAuthChange.emit(this.twoFactorAuth);
  }
}
